function countToValue(element) {
    const countValue = parseInt(element.getAttribute('data-count'), 10);
    const extraCharacter = element.getAttribute('extra-character');
    let currentValue = 0;
    let interval;

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (!interval) {
                    interval = setInterval(() => {
                        if (currentValue <= countValue) {
                            element.textContent = currentValue + extraCharacter;
                            let add = (countValue - currentValue).toString().length - 2;
                            if (add < 0) {
                                currentValue++;
                            } else {
                                currentValue += 10 ** add;
                            }
                        } else {
                            clearInterval(interval);
                        }
                    }, 10);
                }
            } else {
                clearInterval(interval);
                interval = null; // Reset the interval
                currentValue = 0; // Reset the counter
            }
        });
    });
    observer.observe(element);
}

// Loop through each element and start counting
const countXElements = document.querySelectorAll('.count-x');
countXElements.forEach(countToValue);
